import EpisodeCardFooter from './EpisodeCardFooter';

export default EpisodeCardFooter;
